// extracted by mini-css-extract-plugin
module.exports = {"relatedJobsHeadline":"JobRelatedJobsSection-module-related-jobs-headline"};